<template>
  <div>
    <app-header messages="App下载"></app-header>
    <div class="w" id="app_download">
      <div class="wb">
        <div class="app_download_box">
          <h2>把租罗记装进口袋</h2>
          <h3>随时随地租电脑</h3>
          <ul>
            <li>
              <a
                href="https://itunes.apple.com/cn/app/%E7%A7%9F%E7%BD%97%E8%AE%B0/id1451279404?mt=8"
              >
                <i class="iconfont icon-pingguo"></i>iPhone版
              </a>
              <span>
                <img src="/static/images/ios.png">
              </span>
              <em>扫描下载iPhone客户端</em>
            </li>
            <li>
              <a href="http://m.pp.cn/detail.html?appid=7945660&ch_src=pp_dev&ch=default">
                <i class="iconfont icon-ic_android_px"></i>Android版
              </a>
              <span>
                <img src="/static/images/android.png">
              </span>
              <em>扫描下载Android客户端</em>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!--<div v-for="pic in imgArr"></div>-->
    <!---->
    <app-footer></app-footer>
    <!--<phone-footer></phone-footer>-->
  </div>
</template>
<script>
import AppHeader from "../../components/common/Header.vue";
import AppFooter from "../../components/common/Footer.vue";
import PhoneFooter from "../../components/common/Phone.vue";
export default {
  name: "app",
  props: ["detail"],
  components: {
    AppHeader,
    AppFooter,
    PhoneFooter
  },
  metaInfo: {
    title: 'App下载 - 租罗记',
    meta: [
      {
        name: 'keywords',
        content: '租罗记app下载,电脑租赁,免押金,租罗记,商品搜索,免押金租赁,企业租赁电脑,出租办公电脑,租赁苹果电脑,服务器租赁,高配台式机租赁,笔记本电脑租赁,苹果电脑租赁,免押金租电脑,电脑免押金租赁'
      },
      {
        name: 'description',
        content: '租罗记 随租随还，全程保修。中小企业办公电脑优秀之选。'
      }
    ]
  },
  data() {
    return {
      isApps: ""
    };
  },
  created() {
    let isApp = this.appConfig.checkBoxs.checkBox();
    if (isApp === "browser") {
      this.isApps = 1;
    } else if (isApp === "app") {
      this.isApps = 2;
    }
    // if (window.location.hostname !== 'localhost') {
    //   let protocolStr = window.location.protocol;
    //   if (protocolStr == "http:" && process.env.NODE_ENV === "production") {
    //     window.location.href = window.location.href.replace('http', 'https');
    //   }
    // }
    this.loadCustomer(); //加载用户信息
  },
  methods: {
    loadCustomer: function() {
      let that = this;
      let apiUrl = that.appConfig.apiHost + "/v1/app/customer/info/";
      this.axios.get(apiUrl).then(function(response) {
        if (response.status === 200 && response.data.code === 200) {
          that.userInfo = response.data.data;
          window.localStorage.setItem('user-info', JSON.stringify(response.data.data))
        }
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/center/index/app.vue